import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Button } from "@material-ui/core";
import { NotificationManager } from "react-notifications";
import debounce from "lodash/debounce";
import { connect } from "react-redux";

import {
  GetProductDetails,
  GetWishListDetails,
  GetUserLogin,
} from "../../../../services";

import { encryptId } from "../../../../../utils/crypto";
import { addToCart } from "../../../../../store/actions/cartActions";

import { db } from "../../../../../../config/firebase";

import "./topsellers.css";

class Topsellers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /* ==========================================================
         SPECIAL / TOP SELLERS
      ========================================================== */

      productlist: [],
      isLoaded: false,

      title: "Top Sellers",
      isActive: false,

      /* ==========================================================
         CUSTOMER
      ========================================================== */

      wishlist: [],
      custId: null,

      /* ==========================================================
         FIREBASE OFFER
      ========================================================== */

      offerData: {
        status: false,
        title: "",
        englishText: "",
        teluguText: "",
        buttonText: "",
        productId: "",
      },

      offerLoaded: false,

      /* ==========================================================
         QUICK VIEW
      ========================================================== */

      openQuickView: false,
      selectedProduct: null,

      selectedVariants: [],
      totalMoney: 0,

      /* ==========================================================
         PAGINATION
      ========================================================== */

      visibleCount: 12,
    };

    this.debounceHandleAddToWishlistClick = debounce(
      this.handleAddToWishlistClick,
      300,
    );
  }

  /* ==============================================================
     COMPONENT DID MOUNT
  ============================================================== */

  async componentDidMount() {
    try {
      /*
       * ==========================================================
       * DEFAULT OFFER
       * ==========================================================
       */

      let offerData = {
        status: false,
        title: "",
        englishText: "",
        teluguText: "",
        buttonText: "",
        productId: "",
      };

      /*
       * ==========================================================
       * STEP 1
       * LOAD OFFER FROM FIREBASE
       *
       * Firebase:
       *
       * offer
       *   └── offer
       *
       * {
       *   status: true,
       *   title: "...",
       *   english: "...",
       *   telugu: "..."
       * }
       * ==========================================================
       */

      try {
        const offerSnapshot = await db.collection("offer").doc("offer").get();

        console.log("========== OFFER FIREBASE ==========");

        console.log("Offer snapshot exists:", offerSnapshot.exists);

        if (offerSnapshot.exists) {
          const data = offerSnapshot.data();

          console.log("Offer Firebase Data:", data);

          offerData = {
            status: data?.status === true,

            title:
              data?.title !== null && data?.title !== undefined
                ? String(data.title).trim()
                : "",

            englishText:
              data?.english !== null && data?.english !== undefined
                ? String(data.english).trim()
                : "",

            teluguText:
              data?.telugu !== null && data?.telugu !== undefined
                ? String(data.telugu).trim()
                : "",

            buttonText:
              data?.buttonText !== null && data?.buttonText !== undefined
                ? String(data.buttonText).trim()
                : "",

            productId:
              data?.productId !== null && data?.productId !== undefined
                ? String(data.productId).trim()
                : "",
          };
        }

        console.log("Final Offer Data:", offerData);
      } catch (offerError) {
        console.error("Error loading Offer from Firebase:", offerError);

        offerData = {
          status: false,
          title: "",
          englishText: "",
          teluguText: "",
          buttonText: "",
          productId: "",
        };
      }

      /*
       * ==========================================================
       * STEP 2
       * LOAD SPECIAL / TOP SELLER CONFIGURATION
       * ==========================================================
       */

      let specialConfig = null;

      try {
        const snapshot = await db.collection("special").doc("special").get();

        console.log("========== SPECIAL FIREBASE ==========");

        console.log("Special snapshot exists:", snapshot.exists);

        if (snapshot.exists) {
          const data = snapshot.data();

          console.log("Special Firebase Data:", data);

          if (data?.status === true) {
            specialConfig = {
              id: snapshot.id,
              ...data,
            };
          }
        }
      } catch (specialError) {
        console.error("Error loading Special from Firebase:", specialError);
      }

      /*
       * ==========================================================
       * STEP 3
       * LOAD CUSTOMER
       * ==========================================================
       */

      let custId = null;

      const email = sessionStorage.getItem("email");

      if (email) {
        try {
          const user = await GetUserLogin.getCustomerDetail(email);

          if (user && user.data) {
            custId = user.data.id;
          }
        } catch (userError) {
          console.error("Error getting customer details:", userError);
        }
      }

      /*
       * ==========================================================
       * STEP 4
       * DEFAULT SPECIAL VALUES
       * ==========================================================
       */

      let productlist = [];
      let firebaseTitle = "Top Sellers";
      let isActive = false;

      /*
       * ==========================================================
       * STEP 5
       * PROCESS SPECIAL DATA
       *
       * IMPORTANT:
       *
       * We DO NOT return if special is disabled.
       *
       * The OFFER must still be displayed.
       * ==========================================================
       */

      if (specialConfig) {
        isActive = true;

        firebaseTitle = specialConfig.title || "Top Sellers";

        /*
         * ========================================================
         * GET PRODUCT IDS
         * ========================================================
         */

        let ids = Array.isArray(specialConfig.productid)
          ? specialConfig.productid
          : [];

        ids = [
          ...new Set(
            ids
              .filter((id) => id !== null && id !== undefined)
              .map((id) => String(id).trim())
              .filter((id) => id !== ""),
          ),
        ];

        console.log("Special Product IDs:", ids);

        /*
         * ========================================================
         * FETCH PRODUCTS
         * ========================================================
         */

        if (ids.length > 0) {
          productlist = await this.fetchProductDetailsByIds(ids);
        }
      }

      /*
       * ==========================================================
       * STEP 6
       * FINAL STATE
       *
       * VERY IMPORTANT:
       *
       * offerData and offerLoaded MUST be included here.
       * ==========================================================
       */

      this.setState({
        productlist,

        title: firebaseTitle,

        isActive,

        isLoaded: true,

        custId,

        offerData,

        offerLoaded: true,
      });

      console.log("========== FINAL TOPSELLERS STATE ==========");

      console.log({
        productlist,
        firebaseTitle,
        isActive,
        offerData,
      });
    } catch (error) {
      console.error("Error loading Top Sellers / Offer:", error);

      /*
       * ==========================================================
       * EVEN IF SPECIAL FAILS,
       * TRY TO KEEP OFFER VISIBLE IF IT WAS LOADED.
       * ==========================================================
       */

      this.setState({
        productlist: [],
        isLoaded: true,
        isActive: false,
        offerLoaded: true,
      });
    }
  }

  /* ==============================================================
     FETCH PRODUCT DETAILS
  ============================================================== */

  async fetchProductDetailsByIds(ids) {
    try {
      const productPromises = ids.map(async (id) => {
        try {
          const response = await GetProductDetails.getTopSellersById(id);

          if (response && response.success) {
            return response.data;
          }

          return null;
        } catch (error) {
          console.error(`Error fetching product ${id}:`, error);

          return null;
        }
      });

      const results = await Promise.all(productPromises);

      return results
        .filter((product) => product)
        .filter(
          (product, index, self) =>
            index ===
            self.findIndex((item) => String(item.id) === String(product.id)),
        );
    } catch (error) {
      console.error("Error fetching top seller products:", error);

      return [];
    }
  }

  /* ==============================================================
     WISHLIST
  ============================================================== */

  toggleWishlist = (productId) => {
    this.setState((prevState) => {
      const { wishlist } = prevState;

      const isProductInWishlist = wishlist.includes(productId);

      return {
        wishlist: isProductInWishlist
          ? wishlist.filter((id) => id !== productId)
          : [...wishlist, productId],
      };
    });
  };

  handleAddToWishlistClick = async (productId) => {
    const { custId } = this.state;

    if (!custId) {
      NotificationManager.error("Please log in to add items to your wishlist.");

      return;
    }

    const data = {
      custId,
      productId,
    };

    try {
      const result = await GetWishListDetails.addWishlistItem(data);

      if (result) {
        NotificationManager.success("Added to wishlist!");

        this.toggleWishlist(productId);
      } else {
        NotificationManager.error("Product is already in your wishlist.");
      }
    } catch (error) {
      console.error("Error:", error);

      NotificationManager.error(
        "An error occurred while adding to the wishlist.",
      );
    }
  };

  /* ==============================================================
     QUICK VIEW
  ============================================================== */

  handleQuickView = async (productId) => {
    try {
      const response = await GetProductDetails.getProductById(productId);

      if (response && response.success) {
        this.setState({
          selectedProduct: response.data,

          openQuickView: true,

          selectedVariants: [],

          totalMoney: 0,
        });
      }
    } catch (error) {
      console.error("Error loading quick view:", error);
    }
  };

  closeQuickView = () => {
    this.setState({
      openQuickView: false,
      selectedProduct: null,
      selectedVariants: [],
      totalMoney: 0,
    });
  };

  /* ==============================================================
     VARIANT SELECT
  ============================================================== */

  handleVariantSelect = (variant) => {
    this.setState((prev) => {
      const exists = prev.selectedVariants.find(
        (item) => item.id === variant.id,
      );

      let updated;

      if (exists) {
        updated = prev.selectedVariants.filter(
          (item) => item.id !== variant.id,
        );
      } else {
        updated = [...prev.selectedVariants, variant];
      }

      const totalMoney = updated.reduce(
        (sum, item) => sum + Number(item.variantPrice || 0),
        0,
      );

      return {
        selectedVariants: updated,

        totalMoney,
      };
    });
  };

  /* ==============================================================
     ADD TO CART
  ============================================================== */

  handleQuickAddToCart = () => {
    const { selectedProduct, selectedVariants } = this.state;

    if (!selectedProduct || selectedVariants.length === 0) {
      NotificationManager.error("Please select at least one machine variant.");

      return;
    }

    this.props.addToCart(selectedProduct, selectedVariants);

    NotificationManager.success("Added to cart successfully!");

    this.closeQuickView();
  };

  /* ==============================================================
     SHARE
  ============================================================== */

  handleShare = (productId) => {
    const shareUrl = `https://jc-creations.co.in/p/${productId}`;

    if (navigator.share) {
      navigator
        .share({
          title: "Check out this product!",
          url: shareUrl,
        })
        .then(() => console.log("Share successful"))
        .catch((error) => console.log("Sharing failed", error));
    } else {
      alert("Copy this URL: " + shareUrl);
    }
  };

  /* ==============================================================
     SHOW MORE
  ============================================================== */

  handleShowMore = () => {
    this.setState((prevState) => ({
      visibleCount: Math.min(
        prevState.visibleCount + 12,

        prevState.productlist.length,
      ),
    }));
  };

  /* ==============================================================
     OFFER PRODUCT CLICK
  ============================================================== */

  handleOfferClick = () => {
    const { offerData } = this.state;

    if (!offerData || !offerData.productId) {
      NotificationManager.info("Offer product is not available.");

      return;
    }

    this.props.history.push(`/p/${encryptId(offerData.productId)}`);
  };

  /* ==============================================================
     FIREBASE OFFER
  ============================================================== */

  renderFirebaseOffer = () => {
    const { offerData, offerLoaded } = this.state;

    /*
     * Wait until Firebase has been checked.
     */

    if (!offerLoaded) {
      return null;
    }

    /*
     * Offer disabled.
     */

    if (!offerData || offerData.status !== true) {
      return null;
    }

    const hasTitle = Boolean(offerData.title);

    const hasEnglish = Boolean(offerData.englishText);

    const hasTelugu = Boolean(offerData.teluguText);

    /*
     * ==========================================================
     * IMPORTANT:
     *
     * Your Firebase data currently has no buttonText
     * and no productId.
     *
     * Therefore the offer text must still render.
     * ==========================================================
     */

    return (
      <div
        className="premium-firebase-offer"
        style={{
          width: "100%",
          marginBottom: "35px",
          overflow: "hidden",
        }}
      >
        {/* =====================================================
              HEADER
          ===================================================== */}

        <div className="premium-offer-header">
          <div className="premium-offer-accent" />

          <div className="premium-offer-heading">
            <span className="premium-offer-eyebrow">EXCLUSIVE OFFER</span>

            {hasTitle && <h3>{offerData.title}</h3>}
          </div>

          <div className="premium-offer-badge">
            <span className="premium-offer-dot" />
            LIMITED
          </div>
        </div>

        {/* =====================================================
              ENGLISH OFFER
          ===================================================== */}

        {hasEnglish && (
          <div className="premium-offer-marquee">
            <div className="premium-offer-marquee-track">
              <span className="holi-gradient-text">
                {offerData.englishText}
              </span>

              <span className="holi-gradient-text">
                &nbsp;&nbsp;&nbsp; ✦ &nbsp;&nbsp;&nbsp;
                {offerData.englishText}
              </span>

              <span className="holi-gradient-text">
                &nbsp;&nbsp;&nbsp; ✦ &nbsp;&nbsp;&nbsp;
                {offerData.englishText}
              </span>
            </div>
          </div>
        )}

        {/* =====================================================
              TELUGU OFFER
          ===================================================== */}

        {hasTelugu && (
          <div className="premium-offer-marquee telugu">
            <div className="premium-offer-marquee-track reverse">
              <span className="holi-gradient-text">{offerData.teluguText}</span>

              <span className="holi-gradient-text">
                &nbsp;&nbsp;&nbsp; ✦ &nbsp;&nbsp;&nbsp;
                {offerData.teluguText}
              </span>

              <span className="holi-gradient-text">
                &nbsp;&nbsp;&nbsp; ✦ &nbsp;&nbsp;&nbsp;
                {offerData.teluguText}
              </span>
            </div>
          </div>
        )}

        {/* =====================================================
              OPTIONAL BUTTON
          ===================================================== */}

        {offerData.buttonText && offerData.productId && (
          <div className="premium-offer-action">
            <Button
              variant="contained"
              onClick={this.handleOfferClick}
              className="premium-offer-button"
            >
              {offerData.buttonText}

              <span className="premium-offer-arrow">→</span>
            </Button>
          </div>
        )}
      </div>
    );
  };

  /* ==============================================================
     RENDER
  ============================================================== */

  render() {
    const {
      productlist,
      isLoaded,
      wishlist,
      title,
      isActive,
      visibleCount,
      openQuickView,
      selectedProduct,
      selectedVariants,
      totalMoney,
      offerData,
      offerLoaded,
    } = this.state;

    /*
     * ==========================================================
     * WAIT FOR BOTH FIREBASE CHECKS
     * ==========================================================
     */

    if (!isLoaded || !offerLoaded) {
      return (
        <section className="product-items-slider section-padding">
          <div
            className="container"
            id="header-category-bk"
            style={{
              padding: "0 15px",
              textAlign: "center",
            }}
          >
            <div className="progress-bar-bk">
              <CircularProgress color="secondary" />
            </div>
          </div>
        </section>
      );
    }

    /*
     * ==========================================================
     * CHECK WHETHER ANYTHING SHOULD BE DISPLAYED
     *
     * OFFER CAN DISPLAY EVEN WHEN SPECIAL IS OFF.
     * ==========================================================
     */

    const showOffer = offerData && offerData.status === true;

    const showSpecial = isActive === true;

    /*
     * If both are disabled, don't render.
     */

    if (!showOffer && !showSpecial) {
      return null;
    }

    /*
     * ==========================================================
     * MAIN SCREEN
     * ==========================================================
     */

    return (
      <div
        style={{
          width: "100%",
          overflowX: "hidden",
        }}
      >
        <section className="product-items-slider section-padding">
          <div
            className="container"
            id="header-category-bk"
            style={{
              padding: "0 15px",
            }}
          >
            {/* ==================================================
                FIREBASE OFFER
            ================================================== */}

            {showOffer && this.renderFirebaseOffer()}

            {/* ==================================================
                SPECIAL / TOP SELLERS
            ================================================== */}

            {showSpecial && (
              <>
                {/* ===== FIREBASE TITLE ===== */}

                <div className="section-header text-center">
                  <h2>{title}</h2>

                  <hr />
                </div>

                {/* ===== PRODUCTS ===== */}

                <div className="row justify-content-center new-arrivals-productlist">
                  {productlist.length === 0 ? (
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        padding: "20px",
                      }}
                    >
                      <p>No products available.</p>
                    </div>
                  ) : (
                    productlist.slice(0, visibleCount).map((row, index) => (
                      <div
                        key={`${row.id}-${index}`}
                        className="col-12 col-md-6 col-lg-4 col-xl-3 mb-4"
                      >
                        <div
                          className="product"
                          style={{
                            backgroundColor: "black",
                          }}
                        >
                          <Link to={`/p/${encryptId(row.id)}`}>
                            {/* =================================================
                                    IMAGE
                                ================================================= */}

                            <div
                              className="product-header"
                              style={{
                                position: "relative",
                                overflow: "hidden",
                              }}
                            >
                              <img
                                crossOrigin="anonymous"
                                className="img-fluid lazyload"
                                src={row.photo}
                                alt={row.name}
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  objectFit: "contain",
                                  display: "block",
                                  borderRadius: "6px",
                                }}
                              />

                              {/* =================================================
                                      PRODUCT ACTIONS
                                  ================================================= */}

                              <div className="product-actions">
                                <i
                                  className="mdi mdi-eye-outline"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();

                                    this.handleQuickView(row.id);
                                  }}
                                />
                              </div>
                            </div>

                            {/* =================================================
                                    PRODUCT BODY
                                ================================================= */}

                            <div className="product-body">
                              <h6
                                style={{
                                  display: "none",
                                }}
                              >
                                <strong>
                                  <span className="mdi mdi-approval" /> Code
                                </strong>{" "}
                                - {row.slug}
                              </h6>
                            </div>
                          </Link>

                          {/* =================================================
                                  SHARE
                              ================================================= */}

                          <div className="product-footer">
                            <button
                              type="button"
                              className="btn btn-secondary btn-sm float-right"
                              onClick={() => this.handleShare(row.id)}
                            >
                              <i className="mdi mdi-share" /> Share
                            </button>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>

                {/* =================================================
                    SHOW MORE
                ================================================= */}

                {visibleCount < productlist.length && (
                  <div
                    style={{
                      textAlign: "center",
                      marginTop: "30px",
                      marginBottom: "20px",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.handleShowMore}
                      style={{
                        padding: "10px 35px",
                        borderRadius: "30px",
                        textTransform: "none",
                        fontWeight: 600,
                        backgroundColor: "#e96125",
                      }}
                    >
                      Show More
                    </Button>
                  </div>
                )}
              </>
            )}
          </div>
        </section>

        {/* ========================================================
            QUICK VIEW
        ======================================================== */}

        {openQuickView && selectedProduct && (
          <div className="quick-view-overlay">
            <div className="quick-view-modal">
              {/* CLOSE */}

              <button className="close-btn" onClick={this.closeQuickView}>
                ×
              </button>

              <div className="row">
                {/* =================================================
                      IMAGE
                  ================================================= */}

                <div className="col-12 col-lg-4">
                  <img
                    src={selectedProduct.photo}
                    alt=""
                    className="quick-product-image"
                  />
                </div>

                {/* =================================================
                      DETAILS
                  ================================================= */}

                <div className="col-12 col-lg-4">
                  <h2 className="quick-product-title">
                    {selectedProduct.name}
                  </h2>

                  <div className="quick-detail-card">
                    <h5>🧵 Stitch Details</h5>

                    <p>{selectedProduct.stitches}</p>
                  </div>

                  <div className="quick-detail-card">
                    <h5>📏 Dimensions</h5>

                    <p>{selectedProduct.height}</p>
                  </div>

                  <div className="quick-detail-card">
                    <h5>📝 Description</h5>

                    <p>{selectedProduct.sortDesc}</p>
                  </div>
                </div>

                {/* =================================================
                      VARIANTS
                  ================================================= */}

                <div className="col-12 col-lg-4">
                  <div className="variant-header">
                    <h4>Select Machine</h4>

                    <h3>₹{totalMoney}</h3>
                  </div>

                  {selectedProduct.productvariants
                    ?.slice()
                    .sort((a, b) => a.variantName.localeCompare(b.variantName))
                    .map((variant) => {
                      const selected = selectedVariants.some(
                        (item) => item.id === variant.id,
                      );

                      return (
                        <div
                          key={variant.id}
                          className={`variant-card ${selected ? "active" : ""}`}
                          onClick={() => this.handleVariantSelect(variant)}
                        >
                          <div>
                            <strong>{variant.variantName}</strong>
                          </div>

                          <div>₹{variant.variantPrice}</div>
                        </div>
                      );
                    })}
                </div>
              </div>

              {/* =================================================
                    QUICK VIEW FOOTER
                ================================================= */}

              <div className="quick-footer">
                <button
                  className="wishlist-btn-modern"
                  onClick={() =>
                    this.handleAddToWishlistClick(selectedProduct.id)
                  }
                >
                  <i className="mdi mdi-heart-outline" />
                  Wishlist
                </button>

                <button
                  className="cart-btn-modern"
                  onClick={this.handleQuickAddToCart}
                >
                  <i className="mdi mdi-cart" />
                  Add To Cart
                  {totalMoney > 0 && ` • ₹${totalMoney}`}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(null, {
  addToCart,
})(withRouter(Topsellers));
